import styled  from 'styled-components'
import { tokens } from '../../../assets/tokens'

export const MTToolbarStyled = styled.div`
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 15px;
  align-items: center;
  font-weight: 700;
  display: flex;
  justify-content: space-between;

  #totalText{
    margin: 15px 0;
    font-size: 14px;
    font-weight: 400;
    color: ${tokens.color.text.tertiary};
  }

  .actions {
    display: flex;
    flex-wrap: wrap;
  }

`
